import { useRef } from 'react';
import prevLogo from '../../../assets/images/backArrow.svg';
import frontLogo from '../../../assets/images/frontArrow.svg';

export default function GameTypeList (props) {

    const { gameTypeData, setCurrentGameType, currentGameType }= props;
   
    const divRef = useRef(null);

    const scrollLeft = () => {
        divRef.current.scrollBy({
            left: -100,
            behavior: 'smooth'
        })
    }
    const scrollRight = () => {
        divRef.current.scrollBy({
            left: 100,
            behavior: 'smooth'
        })
    }
    return(   <div className='flex relative items-center justify-evenly'>
        <img 
            src={prevLogo} 
            alt="previous" 
            className='bg-bgColor w-8 rounded-full p-2 h-8 cursor-pointer active:bg-white' 
            onClick={scrollLeft} 
        />

        <div ref={divRef} className='flex gap-4 mt-4 w-full ms-4 me-12 overflow-auto no-scrollbar pb-6 items-center relative'>
            {
                gameTypeData && gameTypeData.map((gameType) => (
                    <div 
                        key={gameType.gameTypeId} 
                        className={` ${currentGameType?.gameTypeId === gameType.gameTypeId ? "bg-primary text-bgColor" : "bg-bgColor text-fgColor"} font-semibold px-4 text-nowrap h-[40px] w-[200px] flex items-center cursor-pointer rounded-md`} 
                        onClick={() => setCurrentGameType(gameType)}
                        >{gameType.gameType}
                    </div>
                ))
            }
        </div>
        <img src={frontLogo} alt="previous" className='bg-bgColor w-8 rounded-full p-2 h-8 cursor-pointer active:bg-white absolute right-0' onClick={scrollRight} />
    </div>)
}